import { AnyAction } from 'redux';

import { createAction, State, Type } from './utils';

export const configsRequested = (): AnyAction => createAction(State.actionRequested(Type.GET_ALL_CONFIGS));
export const configsSucceeded = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_ALL_CONFIGS), payload);
